import React, { useEffect, useState } from 'react'
import { useConfig } from "@revenuewell/logic-config"
import { useOidc } from '@revenuewell/logic-oidc'
import { useNotification } from '@revenuewell/logic-notification'
import { useNavigation } from '@revenuewell/logic-navigation'
import { FeatureFlagsContext, FeatureFlagsContextProps } from './context'
import FeatureFlagService from '../../services/feature-flag/feature-flag-service'


export function FeatureFlagsProvider(props: React.PropsWithChildren<unknown>) {
  const { config } = useConfig()
  const { showError } = useNotification()
  const { getClaims, oidcService, signinRedirect } = useOidc()
  const { getLocationIdUrlParam } = useNavigation()
  const [featureFlags, setFeatureFlags] = useState<string[]>()

  useEffect(() => {
    if (config.featureFlags && config.featureFlags.apiUrl)
      loadFeatureFlags()
    else
      setFeatureFlags([])
  }, [])

  const loadFeatureFlags = async () => {
    try {
      const featureFlagService = new FeatureFlagService(config, oidcService)
      const claims = await getClaims()
      const featureFlags = await featureFlagService.getFeatureFlags(getLocationIdUrlParam() || claims.locationId)

      setFeatureFlags(featureFlags)
    } catch (error: any) {
      if(error.status === 401 || error.status === 403)
        signinRedirect()

      showError("Unable to fetch a list of feature flags.")
      console.error(error)
    }
  }

  const hasFlag = (featureFlag: string): boolean => {
    const lowercased = featureFlags?.map(p => p.toLowerCase());
    if(!lowercased) return false;
    return lowercased.indexOf(featureFlag.toLowerCase()) >= 0;
  }

  const context = {
    featureFlags,
    hasFlag: hasFlag
  } as FeatureFlagsContextProps

  return <FeatureFlagsContext.Provider value={{ ...context }}>
    {featureFlags && props.children}
  </FeatureFlagsContext.Provider>
}